export default {
    PrimaryColor:'#e01d20',
    SecondaryColor:'#d42a34',
    TertiaryColor:'#bc4b54',
    ButtonColors:{'background-color':'#ff4d4f','border-color':'#ff4d4f','color':'#fff'},
    // IconColors:{'color':'#EF542F'},
    // TextColor:{'color':'#EC8736','text-decoration':'none'},
    // RecieveTextMessageBubble:{'background-color':'#EC8736','border-color':'#EC8736','color':'#fff'},
    // SendTextMessageBubble:{'background-color':'#EF542F','border-color':'#EF542F','color':'#fff'},
    // BadgePill:{'background-color':'#EF542F','color':'#fff','padding':'2px 10px 2px 10px','border-radius':'10px','z-index':'1','font-size':'10px'}
}

//  C : #e01d20 -this

  // C2 : #d42a34 -this - secondary Color

  // C3 : #bc4b54 - tertiary Color